.header {
  display: none;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 1.6rem 1.6rem 0 1.6rem;

  @media screen and (min-width: $bp-medium) {
    display: flex;
  }
}

.cover {
  position: relative;
  height: 12rem;
  aspect-ratio: 16 / 9;
  border-radius: 0.4rem;
  overflow: hidden;

  &:hover {
    [data-edit-cover] {
      opacity: 1;
      transform: translateX(0) scale(1);
    }
  }
}

.cover-loading {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: #494e5a;
  opacity: 0.8;
}

.pulse-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 9.6rem;
  width: 9.6rem;
  transform: translate(-50%, -50%);
}

.header-image {
  height: 100%;
  max-height: 100%;
  min-height: 100%;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  object-fit: cover;
  border-radius: 0.4rem;
}

.right {
  margin-left: 2.4rem;
  margin-right: 5.6rem;
}

.client {
  font-size: 1.6rem;
  font-weight: 500;
  color: #8a8f98;
}

.infos {
  display: flex;
  flex-direction: column;
  cursor: default;
}

.info-item {
  display: flex;
  align-items: center;
  padding-top: 0.8rem;
}

.text {
  color: var(--date-color);
  font-size: 1.2rem;

  b {
    color: var(--text-color-white);
  }
}

.icon-container {
  padding-right: 0.8rem;
  color: var(--text-color-white);
  font-size: 1.6rem;
  font-weight: 500;

  svg {
    width: 1.6rem;
    height: 1.6rem;
    fill: var(--text-color-white);
  }
}
